import React, { useState } from 'react';
import { Status } from '../../../components';
import Ticks from '../../../assets/images/ticks.svg';
import {
  Box,
  Button,
  Modal,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import activetick from '../../../assets/images/Active_img.svg';
import EquipmentName_Edit from '../../../assets/images/Notification_Edit.svg';
import Status_Icon from '../../../assets/images/Status_Icon.svg';
import EquipmentNamePopup from '../../../components/personalDetailPopup';
import PopupIcon from '../../../assets/images/deletePopup.svg';
import SharedIcon from '../../../assets/images/Shared_Icon.svg';
import { useHook as equipmentHook } from './useHook';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#333333',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: '8px',
    backgroundColor: '#333333',
    border: '1px solid #E9ECEF',
    padding: '16px',
    fontSize: '14px',
    fontWeight: 400,
    color: '#FFFFFF',
  },
}));
interface EquipmentInformationProps {
  equipmentDetailsData: any;
  equipmentPage: string;
}
const EquipmentInformation: React.FC<EquipmentInformationProps> = ({
  equipmentDetailsData,
  equipmentPage,
}) => {
  const { name, id } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openUpdateNamePopup, setOpenUpdateNamePopup] = useState(false);
  const [upgradeYear, setUpgradeYear] = useState(1);
  const { upgradePlan } = equipmentHook();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setUpgradeYear(1);
  };

  //updateEquipmentName
  const handleCloseUpdateNamePopup = () => {
    setOpenUpdateNamePopup(false);
  };
  const handleSupmitUpdateNamePopup = () => {
    setOpenUpdateNamePopup(true);
  };

  //get monthDifference
  function getMonthDifference(startDate: string | number | Date) {
    const start = new Date(startDate);
    const end = new Date();

    const yearsDifference = end.getFullYear() - start.getFullYear();
    const monthsDifference = end.getMonth() - start.getMonth();

    return yearsDifference * 12 + monthsDifference;
  }

  //dateformat
  function formatDate(isoDate: string | Date) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '790px',
    // height: '607px',
    borderRadius: '8px',
    bgcolor: 'background.paper',
    boxShadow: 24,
  };
  const tableData = [
    { data: 'Watch Best Hindi Documentary', icon: Ticks },
    { data: 'Watch Best Hindi Documentary', icon: Ticks },
    { data: 'Watch Best Hindi Documentary', icon: Ticks },
    { data: 'Watch Best Hindi Documentary', icon: Ticks },
    { data: 'Watch Best Hindi Documentary', icon: Ticks },
  ];

  const cardData = [
    {
      price: equipmentDetailsData?.yearlySubscriptionCost,
      year: 1,
      save: 'Save₹98',
    },
    {
      price: equipmentDetailsData?.yearlySubscriptionCost * 2,
      year: 2,
      save: 'Save₹98',
    },
    {
      price: equipmentDetailsData?.yearlySubscriptionCost * 3,
      year: 3,
      save: 'Save₹98',
    },
  ];

  //ShareEquipment
  const shareEquipment = () => {
    if (equipmentPage === 'sharedwithme') {
      navigate(`/equipment/ownedequipment/share/${name}/${id}`);
    } else {
      navigate(`/equipment/ownedequipment/share/${name}/${id}`);
    }
  };

  //add Gst Amount
  function calculateTotalWithGST(baseAmount: number, gstRate: number): number {
    const gstAmount = (baseAmount * gstRate) / 100;
    const totalAmount = baseAmount + gstAmount;
    return totalAmount;
  }

  const handleUpgradePlan = async () => {
    handleClose();
    const payload = {
      unitID: id,
      year: upgradeYear,
    };
    await upgradePlan(payload).then((res) => {
      if (res) {
        window.location.href = res; // External link
        // navigate('/payment')
      }
    });
  };
  return Object.keys(equipmentDetailsData).length > 0 ? (
    <>
      <section className="equipment_information">
        <div className="equipment_information-header">
          <h5>Equipment Information</h5>
          {equipmentPage !== 'sharedwithme' && (
            <Button onClick={shareEquipment}>
              <img src={SharedIcon} width="16" height="16" alt="shareIcon" />
              Share
            </Button>
          )}
        </div>
        <div className="equipment_information-content">
          <div className="equipment_information-content-flex_controller">
            <div className="equipment_information-content-heading">
              <h6>{equipmentDetailsData?.equipmentName || ''}</h6>
              {(equipmentDetailsData?.equipmentAccess === 'WRITE' ||
                equipmentPage !== 'sharedwithme') && (
                <Button onClick={() => setOpenUpdateNamePopup(true)}>
                  <img
                    src={EquipmentName_Edit}
                    alt="EquipmentName_Edit"
                    width={'20'}
                  />
                </Button>
              )}
            </div>

            <div className="equipment_information-heading-section-btn">
              <Button
                className={
                  equipmentDetailsData?.status == 'active'
                    ? 'equipment_information_status-btn'
                    : 'equipment_information_status-btn_change'
                }
              >
                {equipmentDetailsData?.status == 'active'
                  ? 'Online'
                  : 'Offline'}
              </Button>

              {
                <Button
                  className={
                    equipmentDetailsData?.subscriptionStatus == 'active'
                      ? 'equipment_information_status-btn'
                      : 'equipment_information_status-btn_change'
                  }
                >
                  {equipmentDetailsData.subscriptionStatus || 'Inactive'}
                  <BootstrapTooltip
                    title={
                      equipmentDetailsData?.subscriptionEndDate
                        ? `Next payment ${formatDate(equipmentDetailsData?.subscriptionEndDate)}`
                        : '-'
                    }
                    arrow
                  >
                    <img
                      src={Status_Icon}
                      alt="EquipmentName_Edit"
                      width={'20'}
                    />
                  </BootstrapTooltip>
                </Button>
              }

              {equipmentPage !== 'sharedwithme' && (
                <>
                  {(equipmentDetailsData?.subscriptionStatus !== 'active' ||
                    getMonthDifference(
                      equipmentDetailsData?.subscriptionEndDate,
                    ) === 1 ||
                    getMonthDifference(
                      equipmentDetailsData?.subscriptionEndDate,
                    ) === 0) && (
                    <Button
                      className="equipment_information-content-upgrade"
                      type="submit"
                      onClick={handleOpen}
                    >
                      Upgrade Plan
                    </Button>
                  )}

                  <Button
                    className="equipment_information-content-manage"
                    onClick={() => navigate('/manageBilling')}
                  >
                    Manage Billing
                  </Button>
                </>
              )}
            </div>
          </div>

          <div className="equipment_information-content-data">
            <div className="equipment_information-content-data-item">
              <h5>Serial Number</h5>
              <h6>{equipmentDetailsData?.serialNumber || '-'}</h6>
            </div>

            <div className="equipment_information-content-data-item">
              <h5>Gateway No.</h5>
              <h6>{equipmentDetailsData?.gatewayNo || '-'}</h6>
            </div>

            <div className="equipment_information-content-data-item">
              <h5>Registered On</h5>
              <h6>
                {equipmentDetailsData?.registeredOn
                  ? formatDate(equipmentDetailsData?.registeredOn)
                  : '-'}
              </h6>
            </div>

            <div className="equipment_information-content-data-item">
              <h5>Manufactured On</h5>
              <h6>{formatDate(equipmentDetailsData?.createdAt) || '-'}</h6>
            </div>

            <div className="equipment_information-content-data-item">
              <h5>Last Modification</h5>
              <h6>
                <h6>{formatDate(equipmentDetailsData?.updatedAt) || '-'}</h6>
              </h6>
            </div>

            <div className="equipment_information-content-data-item">
              <h5>Category</h5>
              <h6>{equipmentDetailsData?.category || '-'}</h6>
            </div>

            <div className="equipment_information-content-data-item">
              <h5>Sub Category</h5>
              <h6>{equipmentDetailsData?.subCategory || '-'}</h6>
            </div>

            <div className="equipment_information-content-data-item">
              <h5>Equipment type</h5>
              <h6>{equipmentDetailsData?.equipmentModel || '-'}</h6>
            </div>

            {/* <div className="equipment_information-content-data-item">
            <h5>Manufactured By</h5>
            <h6>{equipmentDetailsData?.manufacturedBy || '-'}</h6>
          </div> */}
          </div>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="upgrade_plan">
              <div className="upgrade_plan-head">
                <p>Upgrade Plan</p>
              </div>

              <div className="upgrade_plan-section">
                <div className="upgrade_plan-content">
                  {/* <p>Benefits</p>
                  <div className="upgrade_plan-content_table">
                    {tableData.map((item, index) => (
                      <div
                        className="upgrade_plan-content_table-body"
                        key={index}
                      >
                        <p>{item.data}</p>
                        <span>
                          <img src={item.icon} alt="Ticks" />
                        </span>
                      </div>
                    ))}
                  </div> */}

                  <div className="upgrade_plan-card">
                    {cardData.map((value, index) => (
                      <button
                        onClick={() => setUpgradeYear(value.year)}
                        className={
                          upgradeYear === value.year
                            ? 'upgrade_plan-card-content_active'
                            : 'upgrade_plan-card-content'
                        }
                        key={index}
                      >
                        {upgradeYear === value.year && (
                          <img src={activetick} alt="Tick" />
                        )}
                        <div className="upgrade_plan-card-content-body">
                          <h2>{`₹ ${calculateTotalWithGST(value.price, 18)}`}</h2>
                          <p>{value.year} year </p>
                          {/* <h6>{value.save}</h6> */}
                        </div>
                      </button>
                    ))}
                  </div>

                  <div className="upgrade_plan-footer">
                    <Button
                      className="upgrade_plan-footer-btn_cancel"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="upgrade_plan-footer-btn_upgrade"
                      onClick={() => handleUpgradePlan()}
                    >
                      Upgrade
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>

        <EquipmentNamePopup
          nameData={equipmentDetailsData?.equipmentName || ''}
          open={openUpdateNamePopup}
          handleClose={handleCloseUpdateNamePopup}
          handleSubmit={handleSupmitUpdateNamePopup}
          title={'Name'}
          contentHeading={
            <>
              Are you sure, you want to change your
              <br /> equipment name?
            </>
          }
          // contentSubHeading="Deputy Controller Equipment Name"
          btnText={'Update'}
          imgURL={PopupIcon}
        />
      </section>
    </>
  ) : (
    <></>
  );
};

const MemoizedComponent = React.memo(EquipmentInformation);
export default MemoizedComponent;
